import React from 'react'
import './index.scss'

// 重大事项
const Majors = (props) => {
    return (
        <div className="Majors">
            <h2 className="title">重大事项</h2>
            <table border="1">
                <tr>
                    <th>重大事项</th>
                    <th className="right-th">披露</th>
                </tr>
                <tr>
                    <td>公司减资、合并、分立、解散或申请破产</td>
                    <td>无</td>
                </tr>
                <tr>
                    <td>公司依法进入破产程序</td>
                    <td>无</td>
                </tr>
                <tr>
                    <td>公司被责令停业、整顿、关闭</td>
                    <td>无</td>
                </tr>
                <tr>
                    <td>公司法定代表人、实际控制人、主要负责人、董事、监事、高级管理人员涉及重大诉讼、仲裁，或涉嫌违法违纪被有权机关调查，或受到刑事处罚、重大行政处罚，或被采取强制措施</td>
                    <td>无</td>
                </tr>
                <tr>
                    <td>公司主要或者全部业务陷入停顿</td>
                    <td>无</td>
                </tr>
                <tr>
                    <td>存在欺诈、损害出借人利益等其他影响网络借贷信息中介机构经营活动的重大事项</td>
                    <td>无</td>
                </tr>
            </table>
        </div>
    )
}

export default Majors;


// WEBPACK FOOTER //
// ./src/containers/InfoDcs/Majors/index.js